export type Filmstudio = {
  id: string;
  spillNavn: string;
  arketype: string;
  signaturSjangre: string[];
  forhandlingsTone: string[];
};

export const FILMSTUDIOER: ReadonlyArray<Filmstudio> = [
  {
    id: 'norsk-film-as',
    spillNavn: 'Norsk Film AS',
    arketype: 'Offentlig støttede prosjekter, kvalitet, langsom prosess',
    signaturSjangre: ['LITERARY', 'NONFICTION'],
    forhandlingsTone: [
      '«Vi er allerede i samtale med NFI om finansiering.»',
      '«Vi tar oss tid, men når vi lander så lander vi godt.»',
      '«Dette har den litterære tyngden vi leter etter.»',
    ],
  },
  {
    id: 'bredbandet',
    spillNavn: 'Bredbandet',
    arketype: 'Kommersielt, krim og feelgood, rask',
    signaturSjangre: ['KRIM', 'FEELGOOD', 'ROMANCE'],
    forhandlingsTone: [
      '«Vi tenker premiere allerede neste høst.»',
      '«Dette er en åpenbar bestseller på lerretet.»',
      '«Vi har distribusjonen klar — vi mangler bare manuset.»',
    ],
  },
  {
    id: 'maipo',
    spillNavn: 'Maipo',
    arketype: 'Auteur-tunge prosjekter, festival-fokus',
    signaturSjangre: ['LITERARY', 'POETRY'],
    forhandlingsTone: [
      '«Vi har en regissør i tankene — kan ikke si hvem ennå.»',
      '«Vi vil ha noe Cannes ikke kan ignorere.»',
      '«Boka rommer en film. Vi vil finne den sammen med deg.»',
    ],
  },
  {
    id: 'stranger-studios',
    spillNavn: 'Stranger Studios',
    arketype: 'TV-serie, internasjonal, Netflix-aktig',
    signaturSjangre: ['KRIM', 'FANTASY', 'LITERARY'],
    forhandlingsTone: [
      '«Vi tenker åtte episoder, åpen avslutning, sesong to klar.»',
      '«Vi har et internasjonalt publikum klar til å streame.»',
      '«Norske historier er den nye nordic noir-bølgen.»',
    ],
  },
];

export function finnFilmstudio(id: string): Filmstudio | undefined {
  return FILMSTUDIOER.find((s) => s.id === id);
}

export function velgFilmstudio(sjanger: string, rng: () => number): Filmstudio {
  const norm = sjanger.trim().toUpperCase();
  const matchende = FILMSTUDIOER.filter((s) => s.signaturSjangre.includes(norm));
  const pool = matchende.length > 0 ? matchende : FILMSTUDIOER;
  const idx = Math.floor(rng() * pool.length);
  return pool[Math.min(pool.length - 1, idx)];
}

export function velgFilmstudioTone(studio: Filmstudio, rng: () => number): string {
  if (studio.forhandlingsTone.length === 0) return '';
  const idx = Math.floor(rng() * studio.forhandlingsTone.length);
  return studio.forhandlingsTone[Math.min(studio.forhandlingsTone.length - 1, idx)];
}
